import { render, staticRenderFns } from "./ManBody.vue?vue&type=template&id=13638162&scoped=true&"
import script from "./ManBody.vue?vue&type=script&lang=js&"
export * from "./ManBody.vue?vue&type=script&lang=js&"
import style0 from "./ManBody.vue?vue&type=style&index=0&id=13638162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13638162",
  null
  
)

export default component.exports